<template>
  <div class="list">
    <table v-if="!listLoading">
      <th>
        <!-- 排序 -->
        <td>{{ $t('message[1915]') }}</td>
        <!-- 视图名称 -->
        <td>{{ $t('message[1916]') }}</td>
        <!-- 默认视图 -->
        <td>{{ $t('message[1917]') }}</td>
        <!-- 启用视图 -->
        <td>{{ $t('message[1918]') }}</td>
        <!-- 操作 -->
        <td>{{ $t('message["79"]') }}</td>
      </th>
      <tr
        v-for="(item) in newList.filter(item => item.issystem === 1)"
        :key="item.id"
      >
        <td />
        <td>
          {{ $t('message["904"]') }}
          <!-- 信息配置或者角色权限变更导致该视图已失效 -->
          <p
            v-if="item.status === -1"
            class="fs-gray"
          >
            {{ $t('message["1919"]') }}
          </p>
        </td>
        <td>
          <!-- 默认 -->
          <a-radio
            :checked="item.isdefault == 1"
            :disabled="item.isenable == 0"
            @change="onChangeDefault($event, item)"
          >
            {{ $t('message["654"]') }}
          </a-radio>
        </td>
        <td>
          <!-- 启用 -->
          <a-checkbox
            :checked="item.isenable == 1"
            :disabled="true"
            @change="onChangeEnable($event, item)"
          >
            {{ $t('message["728"]') }}
          </a-checkbox>
        </td>
        <td />
      </tr>
      <draggable
        v-model="newList"
        handle=".move"
        tag="tbody"
        class="draggable-box"
        @end="dragEndHandle"
      >
        <tr
          v-for="(item) in newList"
          v-show="item.issystem !== 1"
          :key="item.id"
        >
          <td class="move">
            <i class="iconfont iconicon-test72 fs-d6 pointer fz-20" />
          </td>
          <td>
            {{ item.name }}
            <!-- 信息配置或者角色权限变更导致该视图已失效 -->
            <p
              v-if="item.status === -1"
              class="fs-gray"
            >
              {{ $t('message["1919"]') }}
            </p>
          </td>
          <td>
            <!-- 默认 -->
            <a-radio
              :checked="item.isdefault == 1"
              :disabled="item.status === -1 || item.isenable == 0"
              @change="onChangeDefault($event, item)"
            >
              {{ $t('message["654"]') }}
            </a-radio>
          </td>
          <td>
            <!-- 启用 -->
            <a-checkbox
              :checked="item.isenable == 1"
              :disabled="item.status === -1 || item.isdefault == 1"
              @change="onChangeEnable($event, item)"
            >
              {{ $t('message["728"]') }}
            </a-checkbox>
          </td>
          <td>
            <!-- 编辑 -->
            <a
              v-if="item.issystem !== 1"
              class="edit-btn m-r-16"
              @click="handleDetail(item.id, item.name)"
            >{{ $t('message["36"]') }}</a>
            <!-- 删除 -->
            <a
              v-if="item.issystem !== 1"
              class="del-btn"
              @click="handleDelete(item)"
            >{{ $t('message["962"]') }}</a>
          </td>
        </tr>
      </draggable>
    </table>
    <div
      v-if="!listLoading && !newList.length"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        {{ $t('message["1553"]') }}
      </p>
    </div>
    <a-spin
      v-if="listLoading && !newList.length"
      class="spin-fixed-center"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    page: {
      type: String,
      default: ''
    },
    role: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      newList: []
    }
  },
  computed: {
    ...mapState('config/listview', ['listLoading'])
  },
  watch: {
    listData: {
      handler (val) {
        if (val) {
          this.newList = val
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('config/listview', ['deleteView', 'setDefaultView', 'setEnableView', 'setSort']),
    async onChangeDefault (e, item) {
      item.isdefault = e.target.checked ? 1 : 0
      let chain = await this.setDefaultView({ viewid: item.id })
      chain.onSuccess(res => {
        this.$emit('updateList', {
          page: this.page,
          role: this.role
        })
      })
    },
    async onChangeEnable (e, item) {
      item.isenable = e.target.checked ? 1 : 0
      await this.setEnableView({ viewid: item.id })
    },
    handleDetail (id, name) {
      this.$bus.$emit('showDetailModal', id, name)
    },
    handleDelete (item) {
      this.$confirm({
        title: this.$t('message["1920"]'), // 删除视图
        content: this.$t('message["1921"]'), // 视图删除后不可恢复，确定要删除吗？
        closable: true,
        okText: this.$t('message["466"]'), //  继续
        okType: 'primary',
        cancelText: this.$t('message["896"]'), // 取消
        class: 'confirm-warn-modal del-email-modal',
        onOk: async () => {
          this.confirmDelete(item)
        }
      })
    },
    async confirmDelete (item = {}) {
      const { id, isdefault } = item
      let chain = await this.deleteView({ viewid: id })
      chain.onSuccess(async (res) => {
        // 如果默认值的视图被删除，视图全部变为默认
        let issystemItem = this.newList.find(item => item.issystem)
        if (isdefault === 1) {
          await this.setDefaultView({ viewid: issystemItem.id })
        }
        this.$emit('updateList', {
          page: this.page,
          role: this.role
        })
      })
    },
    async dragEndHandle ({ oldIndex, newIndex }) {
      let sort = this.newList.map(item => item.id)
      let chain = await this.setSort({
        page: this.page,
        role: this.role,
        sort
      })
      chain.onSuccess(res => {
        this.$emit('updateList', {
          page: this.page,
          role: this.role
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  th,tr {
    display: table-row;
  }
  th {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
    background: #F5F6F7;
    td {
      padding: 0 16px;
    }
  }
  tr {
    background-color: #fff;
    border-bottom: solid 1px #ebebeb;
  }
  tr td {
    height: 64px;
    padding: 22px 16px;
    vertical-align: middle;
  }

  .ant-checkbox-wrapper {
    margin-bottom: 0;
  }
}
</style>
